// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DTAStatus } from './dta-status';
import {
    DTAStatusFromJSON,
    DTAStatusFromJSONTyped,
    DTAStatusToJSON,
    DTAStatusToJSONTyped,
} from './dta-status';
import type { CreateDTAResponsePrepopulationMetadata } from './create-dta-response-prepopulation-metadata';
import {
    CreateDTAResponsePrepopulationMetadataFromJSON,
    CreateDTAResponsePrepopulationMetadataFromJSONTyped,
    CreateDTAResponsePrepopulationMetadataToJSON,
    CreateDTAResponsePrepopulationMetadataToJSONTyped,
} from './create-dta-response-prepopulation-metadata';

/**
 * 
 * @export
 * @interface CreateDTAResponse
 */
export interface CreateDTAResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateDTAResponse
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDTAResponse
     */
    created_by: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDTAResponse
     */
    domains: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateDTAResponse
     */
    dta_id: string;
    /**
     * 
     * @type {CreateDTAResponsePrepopulationMetadata}
     * @memberof CreateDTAResponse
     */
    prepopulation_metadata?: CreateDTAResponsePrepopulationMetadata;
    /**
     * 
     * @type {DTAStatus}
     * @memberof CreateDTAResponse
     */
    status: DTAStatus;
    /**
     * 
     * @type {string}
     * @memberof CreateDTAResponse
     */
    study_id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDTAResponse
     */
    vendor_id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDTAResponse
     */
    vendor_name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDTAResponse
     */
    version: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDTAResponse
     */
    workflow_stage: string;
}



/**
 * Check if a given object implements the CreateDTAResponse interface.
 */
export function instanceOfCreateDTAResponse(value: object): value is CreateDTAResponse {
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('created_by' in value) || value['created_by'] === undefined) return false;
    if (!('domains' in value) || value['domains'] === undefined) return false;
    if (!('dta_id' in value) || value['dta_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('study_id' in value) || value['study_id'] === undefined) return false;
    if (!('vendor_id' in value) || value['vendor_id'] === undefined) return false;
    if (!('vendor_name' in value) || value['vendor_name'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('workflow_stage' in value) || value['workflow_stage'] === undefined) return false;
    return true;
}

export function CreateDTAResponseFromJSON(json: any): CreateDTAResponse {
    return CreateDTAResponseFromJSONTyped(json, false);
}

export function CreateDTAResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDTAResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'created_at': json['created_at'],
        'created_by': json['created_by'],
        'domains': json['domains'],
        'dta_id': json['dta_id'],
        'prepopulation_metadata': json['prepopulation_metadata'] == null ? undefined : CreateDTAResponsePrepopulationMetadataFromJSON(json['prepopulation_metadata']),
        'status': DTAStatusFromJSON(json['status']),
        'study_id': json['study_id'],
        'vendor_id': json['vendor_id'],
        'vendor_name': json['vendor_name'],
        'version': json['version'],
        'workflow_stage': json['workflow_stage'],
    };
}

export function CreateDTAResponseToJSON(json: any): CreateDTAResponse {
    return CreateDTAResponseToJSONTyped(json, false);
}

export function CreateDTAResponseToJSONTyped(value?: CreateDTAResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'created_at': value['created_at'],
        'created_by': value['created_by'],
        'domains': value['domains'],
        'dta_id': value['dta_id'],
        'prepopulation_metadata': CreateDTAResponsePrepopulationMetadataToJSON(value['prepopulation_metadata']),
        'status': DTAStatusToJSON(value['status']),
        'study_id': value['study_id'],
        'vendor_id': value['vendor_id'],
        'vendor_name': value['vendor_name'],
        'version': value['version'],
        'workflow_stage': value['workflow_stage'],
    };
}
